import React from 'react'
import { selectorFamily, useRecoilState, useRecoilValue } from 'recoil'
import { useDispatch } from 'react-redux'
import { setModalOptions, setModalPrimaryBtnDisabled } from '@landscape/ui-redux'
import { SecondaryButton } from '@cb/apricot-react'
import { useLazyQuery } from '@apollo/client'
import filter from 'lodash/filter'
import { jobStatus } from '../Utils'
import { GET_QC_CSV_CONTENTS } from '@landscape/gql'
import { Spinner } from '../Spinner'
import { QualityControlTable } from './qcModal'
import { inProgressQCAtom } from '../recoil-context'

const inProgressQCSelector = selectorFamily({
  key: 'isThisQCFileLoading',
  get:
    (jobId) =>
    ({ get }) => {
      const qcLoadingList = get(inProgressQCAtom)
      return qcLoadingList.includes(jobId)
    },
})

export const DataQualityFiles: React.FC<any> = (props: any) => {
  const { clientType } = props
  const jobId = props.row.id.toString()
  const { statusCode, fileName, diCode } = props.row

  const [currDownloadingQCs, setCurrDownloadingQCs] = useRecoilState(inProgressQCAtom)
  const loading = useRecoilValue(inProgressQCSelector(jobId))

  const [getCsvContents] = useLazyQuery(GET_QC_CSV_CONTENTS, {
    fetchPolicy: 'network-only',
    variables: { input: { jobId, diCode: diCode.toString(), fileName } },
  })

  const dispatch = useDispatch()

  const column = props.column
  const justify = column.justify || 'start'
  if (statusCode !== jobStatus.DONE) {
    return (
      <>
        <div className={`cb-padding-left-8 display-flex justify-content-${justify}`}>N/A</div>
      </>
    )
  }

  const setLoading = (setLoadingTrue: boolean) => {
    if (setLoadingTrue) {
      setCurrDownloadingQCs(currDownloadingQCs.concat(jobId))
    } else {
      // remove from in progress qc ids
      setCurrDownloadingQCs(filter(currDownloadingQCs, (item) => jobId !== item))
    }
  }

  const downloadQcAsCsvHandler = async () => {
    setLoading(true)
    const {
      data: { getQcAsCsvQueryExternalAdmin },
    } = await getCsvContents()

    const csvContent = 'data:text/csv;charset=utf-8,' + getQcAsCsvQueryExternalAdmin.contents

    const encodedUri = encodeURI(csvContent)
    const link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `${fileName}.csv`)
    document.body.appendChild(link) // Required for FF

    link.click() // This will download the data file named "my_data.csv".

    setLoading(false)
  }

  const openQcModal = () => {
    const qcModalOptions = {
      showModal: true,
      body: [
        <QualityControlTable
          key="qcModal"
          diCode={diCode}
          jobId={jobId}
          clientType={clientType}
          onDataLoadCallback={() => {
            dispatch(setModalPrimaryBtnDisabled(false))
          }}
        />,
      ],
      status: 'success',
      title: `QC File Check`,
      confirm: true,
      primaryLabel: 'Download Full Results',
      primaryDisabled: true,
      handlerFunction: downloadQcAsCsvHandler,
    }
    dispatch(setModalOptions(qcModalOptions))
  }

  if (loading) {
    return <Spinner showSpinner={true} size="xs" id="qc-report-download" ariaLabel="Downloading..." />
  }

  return (
    <SecondaryButton onClick={openQcModal} type="button" className="summarize-file-btn cb-btn-small cb-btn-filter">
      Summarize File
    </SecondaryButton>
  )
}
